import React, { useCallback } from 'react';
import { Flex, Box, Heading, Text, TextLink } from '@feast-it/pesto';
import { useFormikContext } from 'formik';

import LocationAutocomplete from '../../../../components/LocationAutocomplete';
import SupplierManual from './Manual';
import { trackEvent } from '../../../../modules/analytics';
import {
  SUPPLIER_FORM_MANUAL_ADDRESS_CLICKED,
  SUPPLIER_FORM_AUTOCOMPLETE_ADDRESS_CLICKED,
} from '../../../../constants/analytics';

function SupplierLocation() {
  const { values, setFieldValue } = useFormikContext();

  const setManualSupplierLocation = useCallback(() => {
    const trackingKey = !values.supplier.manualLocation
      ? SUPPLIER_FORM_MANUAL_ADDRESS_CLICKED
      : SUPPLIER_FORM_AUTOCOMPLETE_ADDRESS_CLICKED;

    trackEvent(trackingKey);

    setFieldValue('supplier.manualLocation', !values.supplier.manualLocation);

    // Reset field values when switching
    setFieldValue('supplier.locationAutocomplete', { value: '', label: '' });
    setFieldValue('supplier.location_line_1', '');
    setFieldValue('supplier.location_line_2', '');
    setFieldValue('supplier.location_city', '');
    setFieldValue('supplier.postcode', '');
  }, [setFieldValue, values.supplier.manualLocation]);

  const showManualLocation = values?.supplier.manualLocation;

  return (
    <Flex alignItems="center" flexDirection="column">
      <>
        <Box width="100%" maxWidth="600px" mb={{ _: 6, m: 8 }}>
          <Heading
            textAlign="center"
            mb={{ _: 2, m: 4 }}
            color="blueDark"
            fontSize={{ _: 'headingExtraLargeMobile', m: 'headingLargeMobile' }}
            lineHeight={{
              _: 'headingExtraLargeMobile',
              m: 'headingLargeMobile',
            }}
            fontWeight={500}
          >
            Where are you based?
          </Heading>

          <Text
            color="blueDark"
            textAlign="center"
            mb={4}
            fontFamily="body"
            fontSize={{ _: 'body', m: 'headingMediumMobile' }}
            lineHeight={{ _: 'body', m: 'headingMediumMobile' }}
          >
            We use this to match you with events in your area.
          </Text>
        </Box>

        <Box mb={5} width="100%" maxWidth={600}>
          {!showManualLocation ? (
            <LocationAutocomplete
              name="supplier.locationAutocomplete"
              placeholder="Start typing your address"
            />
          ) : (
            <SupplierManual />
          )}
          <Flex my={5} justifyContent="center">
            <TextLink
              fontFamily="body"
              fontSize={{ _: 'small', m: 'body' }}
              lineHeight={{ _: 'small', m: 'body' }}
              color="blueMedium"
              type="button"
              onClick={() => {
                setManualSupplierLocation();
              }}
              fontWeight={600}
            >
              {showManualLocation
                ? 'Or search for your address'
                : 'Or enter your address manually'}
            </TextLink>
          </Flex>
        </Box>
      </>
    </Flex>
  );
}

export default SupplierLocation;
